import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_2 = { class: "inline-flex q-mb-xs" }
const _hoisted_3 = { class: "move-row" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_position_row = _resolveComponent("position-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.moveTypeName(_ctx.el.MovementType)
        }, null, 8, _hoisted_4),
        (!_ctx.hideInfoBtn && _ctx.el.Id > 0)
          ? (_openBlock(), _createBlock(_component_app_icon, {
              key: 0,
              class: "move-row__info q-mr-xs",
              name: "info-circle-outline",
              width: "18px",
              color: "#979797",
              "hover-color": "#499259",
              cursor: "pointer",
              title: _ctx.$t('info'),
              onClick: _ctx.openInfoDialog
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['move-row']),
          innerHTML: _ctx.displayHtml
        }, null, 8, _hoisted_5)
      ]),
      (!_ctx.hideRemoveBtn)
        ? (_openBlock(), _createBlock(_component_app_icon, {
            key: 0,
            class: "ml-1 move-row__remove",
            name: "close",
            width: "16px",
            color: "#979797",
            "hover-color": "#616161",
            cursor: "pointer",
            title: _ctx.$t('remove'),
            onClick: _withModifiers(_ctx.detach, ["stop"])
          }, null, 8, ["title", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPositions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.el.Items, (pos, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row no-wrap items-baseline",
              key: 'item_pos_' + idx
            }, [
              _createTextVNode(_toDisplayString(idx + 1) + ")  ", 1),
              _createVNode(_component_position_row, {
                id: pos.Id,
                el: _ctx.getPositionFromNameInstance(pos),
                "hide-info-btn": true
              }, null, 8, ["id", "el"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}